import { create } from 'zustand';

type PreZenModeState = {
  rightSidebarOpen: boolean;
};

type ZenModeStore = {
  isZenMode: boolean;
  preZenState: PreZenModeState | null;
  setZenMode: (enabled: boolean) => void;
  toggleZenMode: () => void;
  setPreZenState: (state: PreZenModeState | null) => void;
};

export const useZenModeStore = create<ZenModeStore>((set) => ({
  isZenMode: false,
  preZenState: null,
  setZenMode: (enabled) => set({ isZenMode: enabled }),
  toggleZenMode: () => set((state) => ({ isZenMode: !state.isZenMode })),
  setPreZenState: (preZenState) => set({ preZenState }),
}));
